
import {connect} from 'react-redux';
import axios from 'axios';

import EnterCodeScreen from '../EnterCodeScreen';
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
 import * as NavigationService from "../../../../../redux/NavigationService";
import {serviceActionSetState, serviceActionSetToken, serviceActionSetUser} from '../../../splash/action/ActionSplashGetAllData'
import {addAllFormData,SaveTokenUserAsyncProps} from '../../../../../tools/Tools1';

const mapStateToProps = (state) => ({
    results: state.reducerEnterCodeScreen.results,
    NoInternetDialog: state.reducerEnterCodeScreen.NoInternetDialog,
    isLoading: state.reducerEnterCodeScreen.isLoading,
    DataSplashScreen: state.reducerSplashGetAllData,

});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData) => {

    dispatch(serviceActionPending());
    const formData = new FormData();
    // formData.append('_operation', params._operation);
    // formData.append('mode', params.mode);

    formData.append('_operation', typeExport._Registration);
    formData.append('mode', 'VerifyCode');
    formData.append('lang', params.lang);
    formData.append('mobile', params.mobile);
    formData.append('code', params.code);
    addAllFormData(formData,true,"City");

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
        }
    };
    /*    axios(
            {
                url: url ,
                method: typeConnection,
                params:params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },

            }
        )*/
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
    //axios.post(url, formData, config)
        .then(async response => {
            /*  0 => ثبت نام نیست
               1=> ثبت نام شده رمز انتخاب نکرده یا فراموشی رمز عبور
              2=> ثبت نام شده رمز انتخاب کرده*/
            if (response.data.success) {
                global.CodeMobile = params.code
                dispatch(serviceActionSuccess(response.data))

                if (getState.route.params.type == 'forgot_my_password') {
                  SaveTokenUserAsyncProps(response.data.result.token, response.data.result);

                    NavigationService.replace("ChangePassScreen", {forgot_my_password: true,})

                } else {
                    switch (type) {

                        case typeExport.TypegetDataEnterCodeScreen:
                            if (response.data.success) {
                                switch (response.data.result.status) {

                                    case "0" :
                                       // NavigationService.PopToPop();

                                        NavigationService.replace("InformationScreen", {
                                            mobile: getState.route.params.mobile,
                                            type: getState.route.params.type
                                        })

                                        break;

                                    /* case "1":
                                         //   await AsyngStorageClass.setToken()
                                         NavigationService.navigateParams("ChangePassScreen")

                                         break;*/

                                    case "2":
                                     SaveTokenUserAsyncProps(response.data.result.token, response.data.result)
                                        //NavigationService.resetTo("Drawer")
                                       // NavigationService.PopToPop();

                                        try {

                                            NavigationService.navigateParams(store.getState().reducerSplashGetAllData.STATE.type)
                                            //    NavigationService.navigateParams('ProfileStack')
                                        } catch (e) {
                                            //NavigationService.resetTo("Drawer")
                                        }
                                        break;
                                    default:

                                }
                            } else {

                                alert(response.data.error.message)
                                dispatch(serviceActionRefresh())

                            }

                            break;

                        default:
                    }
                }
            } else {
                dispatch(serviceActionRefresh())
                alert(response.data.error.message)
            }


        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        } else {
            dispatch(serviceActionError("No Internet Connection"));
        }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.EnterCodeScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.EnterCodeScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.EnterCodeScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.EnterCodeScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(EnterCodeScreen);
